// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606161033/js/" + chunkId + "." + {"44":"f12aaacf","225":"5028760d","481":"3479fcec","486":"2294a660","770":"4f38a53f"}[chunkId] + ".0.1636551179300002.chunk.js";
};